import { Link, useLocation } from "react-router-dom";

const PAGES = {
  "/privacy": {
    eyebrow: "Privacy",
    title: "Privacy Policy",
    intro: "This bridge page is designed to send visitors to a third-party offer. We keep this policy short and plain English.",
    sections: [
      {
        heading: "What we collect",
        body: "We do not ask for sensitive personal information on this page. Standard web hosting, analytics, or ad tools may collect technical data such as IP address, browser type, device information, referrer, and page visits.",
      },
      {
        heading: "How it is used",
        body: "That information may be used to understand traffic sources, measure link clicks, improve the page, prevent abuse, and evaluate advertising performance.",
      },
      {
        heading: "Third-party offers",
        body: "If you click through to an external vendor page, that vendor controls its own checkout, privacy practices, cookies, and support processes. Review the vendor's own privacy policy before you buy.",
      },
      {
        heading: "Contact",
        body: "Questions about this page can be sent to hello@the-managerly.com.",
      },
    ],
  },
  "/terms": {
    eyebrow: "Terms",
    title: "Terms & Disclosure",
    intro: "This page provides introductory information only and is not the seller's official checkout page.",
    sections: [
      {
        heading: "Affiliate disclosure",
        body: "We may earn a commission if you click a link on this page and make a purchase, at no extra cost to you.",
      },
      {
        heading: "No guarantees",
        body: "Any decision to purchase should be based on the vendor's official sales page, terms, and refund policy. We do not guarantee results, income, health outcomes, or any specific personal outcome from a third-party product.",
      },
      {
        heading: "Third-party responsibility",
        body: "The product vendor is responsible for the offer details, checkout, fulfillment, billing, customer support, and refunds. Always verify the final offer information on the vendor page before purchasing.",
      },
      {
        heading: "Use of this page",
        body: "By using this page, you agree to evaluate the offer independently and not rely on this page as professional, legal, medical, financial, or business advice.",
      },
    ],
  },
};

export default function LegalPage() {
  const { pathname } = useLocation();
  const page = PAGES[pathname];

  if (!page) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
          <h1 className="font-display text-4xl tracking-tight mb-5">Page not found</h1>
          <Link to="/bridge" className="text-white/70 hover:text-[#FF3B30] transition-colors">Back to bridge</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#F2B807] mb-5">{page.eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-5">{page.title}</h1>
        <p className="text-white/70 max-w-2xl mb-12">{page.intro}</p>

        <div className="space-y-8">
          {page.sections.map((section) => (
            <section key={section.heading} className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
              <h2 className="font-display text-2xl mb-3">{section.heading}</h2>
              <p className="text-white/70 leading-relaxed">{section.body}</p>
            </section>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap gap-4 text-sm text-white/60">
          <Link to="/bridge" className="hover:text-[#FF3B30] transition-colors">Back to bridge</Link>
          <a href="mailto:hello@the-managerly.com" className="hover:text-[#FF3B30] transition-colors">Contact</a>
        </div>
      </div>
    </div>
  );
}
